import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_396: DocMigration = {
  maxSchemaVersion: "0.0.396",
  description: "Remove unused properties from propInstances",
  apply(json: any) {
    if (!json.propInstances) {
      return json;
    }

    for (const instanceId in json.propInstances) {
      const instance = json.propInstances[instanceId];
      delete instance.addToFoundationPlan;
      delete instance.addToUtilityPlan;
    }

    return json;
  },
};

export default migration_0_0_396;
